import * as React from 'react'
import {Box} from "@mui/material";
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components";


export default function countryColumn() {
    return [{
        name: 'country',
        label: 'Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'country', label: 'Country',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <LabelCountry country={value} label={translateCountryName(value)} />
            </Box>
        }
    }]
}